import useSWR from 'swr'

import { Loading } from '@/components/Loading'
import { SettingsPage } from '@/containers/Settings/SettingsLayout'
import { apiFetcher } from '@/data/fetcher'
import { NavigationSettingsForm } from '@/forms/NavigationSettingsForm/NavigationSettingsForm'
import { Settings } from '@/interfaces/Settings'

export default function SettingsNavigationPage() {
  const { data: settings, isLoading, mutate } = useSWR<Settings>('/api/v2/settings', apiFetcher)

  return (
    <SettingsPage
      title="Navigace v aplikaci"
      description="Jak se aplikace chová při práci se seznamy. Nastavení platí pro všechny uživatele firmy."
      breadcrumbHref="/settings/navigation"
    >
      {isLoading && <Loading />}

      {settings && <NavigationSettingsForm defaultValues={{ documentRowClick: settings.documentRowClick }} onSuccess={() => mutate()} />}
    </SettingsPage>
  )
}
